import _regenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _wrapNativeSuper from "/usr/app/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper.js";
import _createClass from "/usr/app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _classCallCheck from "/usr/app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _callSuper from "/usr/app/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "/usr/app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _defineProperty from "/usr/app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import fetcher from "@/common/axiosInstance";
import UnprocessableEntityError from "@/exceptions/UnprocessableEntityError";
import { ValidationException } from "@/common/exceptions/ValidationException";
export var OrderPaidError = /*#__PURE__*/function (_UnprocessableEntityE) {
  function OrderPaidError() {
    var _this;
    _classCallCheck(this, OrderPaidError);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, OrderPaidError, [].concat(args));
    _defineProperty(_this, "name", "OrderPaidError");
    return _this;
  }
  _inherits(OrderPaidError, _UnprocessableEntityE);
  return _createClass(OrderPaidError);
}(UnprocessableEntityError);
export var PostReservedError = /*#__PURE__*/function (_UnprocessableEntityE2) {
  function PostReservedError() {
    var _this2;
    _classCallCheck(this, PostReservedError);
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }
    _this2 = _callSuper(this, PostReservedError, [].concat(args));
    _defineProperty(_this2, "name", "PostReservedError");
    return _this2;
  }
  _inherits(PostReservedError, _UnprocessableEntityE2);
  return _createClass(PostReservedError);
}(UnprocessableEntityError);
export var TamaraValidationError = /*#__PURE__*/function (_Error) {
  function TamaraValidationError(validationErrors) {
    var _this3;
    _classCallCheck(this, TamaraValidationError);
    _this3 = _callSuper(this, TamaraValidationError, ["Validation error"]);
    _this3.name = "TamaraValidationError";
    _this3.validationErrors = validationErrors;
    return _this3;
  }
  _inherits(TamaraValidationError, _Error);
  return _createClass(TamaraValidationError);
}(/*#__PURE__*/_wrapNativeSuper(Error));
export var api__createTamaraCheckoutSession = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(requestData) {
    var _response$data, response, _response$data2, _response$data2$data, _response$data3, _response$data3$data, _response$data4, _response$data4$data, _response$data6, _response$data6$valid, _response$data5, _response$data5$data, _error$data, _error$data$data, _error$data2, _error$data2$data, _error$data3, _error$data3$validati, _t;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.p = _context.n) {
        case 0:
          _context.p = 0;
          _context.n = 1;
          return fetcher().post("/tamara/create-checkout-session", requestData);
        case 1:
          response = _context.v;
          if (!(response !== null && response !== void 0 && (_response$data = response.data) !== null && _response$data !== void 0 && _response$data.success)) {
            _context.n = 2;
            break;
          }
          return _context.a(2, response.data);
        case 2:
          if (!((response === null || response === void 0 ? void 0 : (_response$data2 = response.data) === null || _response$data2 === void 0 ? void 0 : (_response$data2$data = _response$data2.data) === null || _response$data2$data === void 0 ? void 0 : _response$data2$data.error_type) === "order_already_paid")) {
            _context.n = 3;
            break;
          }
          throw new OrderPaidError('order_already_paid');
        case 3:
          if (!((response === null || response === void 0 ? void 0 : (_response$data3 = response.data) === null || _response$data3 === void 0 ? void 0 : (_response$data3$data = _response$data3.data) === null || _response$data3$data === void 0 ? void 0 : _response$data3$data.error_type) === "post_reserved")) {
            _context.n = 4;
            break;
          }
          throw new PostReservedError('post_already_reserved');
        case 4:
          if (!((response === null || response === void 0 ? void 0 : (_response$data4 = response.data) === null || _response$data4 === void 0 ? void 0 : (_response$data4$data = _response$data4.data) === null || _response$data4$data === void 0 ? void 0 : _response$data4$data.error_type) === "validation_error")) {
            _context.n = 5;
            break;
          }
          throw new ValidationException((response === null || response === void 0 ? void 0 : (_response$data5 = response.data) === null || _response$data5 === void 0 ? void 0 : (_response$data5$data = _response$data5.data) === null || _response$data5$data === void 0 ? void 0 : _response$data5$data.message) || 'Validation error');
        case 5:
          if (!(response !== null && response !== void 0 && (_response$data6 = response.data) !== null && _response$data6 !== void 0 && (_response$data6$valid = _response$data6.validation_errors) !== null && _response$data6$valid !== void 0 && _response$data6$valid.length)) {
            _context.n = 6;
            break;
          }
          throw new TamaraValidationError(response.data.validation_errors);
        case 6:
          throw new Error('Unknown error');
        case 7:
          _context.n = 12;
          break;
        case 8:
          _context.p = 8;
          _t = _context.v;
          if (!((_t === null || _t === void 0 ? void 0 : (_error$data = _t.data) === null || _error$data === void 0 ? void 0 : (_error$data$data = _error$data.data) === null || _error$data$data === void 0 ? void 0 : _error$data$data.error_type) === "order_already_paid")) {
            _context.n = 9;
            break;
          }
          throw new OrderPaidError('order_already_paid');
        case 9:
          if (!((_t === null || _t === void 0 ? void 0 : (_error$data2 = _t.data) === null || _error$data2 === void 0 ? void 0 : (_error$data2$data = _error$data2.data) === null || _error$data2$data === void 0 ? void 0 : _error$data2$data.error_type) === "post_reserved")) {
            _context.n = 10;
            break;
          }
          throw new PostReservedError('post_already_reserved');
        case 10:
          if (!(_t !== null && _t !== void 0 && (_error$data3 = _t.data) !== null && _error$data3 !== void 0 && (_error$data3$validati = _error$data3.validation_errors) !== null && _error$data3$validati !== void 0 && _error$data3$validati.length)) {
            _context.n = 11;
            break;
          }
          throw new TamaraValidationError(_t.data.validation_errors);
        case 11:
          throw _t;
        case 12:
          return _context.a(2);
      }
    }, _callee, null, [[0, 8]]);
  }));
  return function api__createTamaraCheckoutSession(_x) {
    return _ref.apply(this, arguments);
  };
}();
export var api__cancelTamaraOrder = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(requestData) {
    var _response$data7, response, _t2;
    return _regenerator().w(function (_context2) {
      while (1) switch (_context2.p = _context2.n) {
        case 0:
          _context2.p = 0;
          _context2.n = 1;
          return fetcher().post("/tamara/order-cancel", requestData);
        case 1:
          response = _context2.v;
          if (!(response !== null && response !== void 0 && (_response$data7 = response.data) !== null && _response$data7 !== void 0 && _response$data7.success)) {
            _context2.n = 2;
            break;
          }
          return _context2.a(2, response.data);
        case 2:
          _context2.n = 4;
          break;
        case 3:
          _context2.p = 3;
          _t2 = _context2.v;
          throw _t2;
        case 4:
          return _context2.a(2);
      }
    }, _callee2, null, [[0, 3]]);
  }));
  return function api__cancelTamaraOrder(_x2) {
    return _ref2.apply(this, arguments);
  };
}();